import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useSetting } from '../../../../utilities/sharedHooks/settings';
import { CardSettingsContext } from '../../../../contexts/card/settings/context';
import {
  CARD_GALILEO_REPORT_DAMAGED,
  CARD_GALILEO_REPORT_LOST,
  CARD_GALILEO_REPORT_STOLEN,
  CARD_ORDER_REPLACEMENT,
} from '../../mutations';
import { REPORT_CARD_STATUS } from '../../../../utilities/constants';
import { showAlert } from '../../../../utilities/notifications';
import { cardSettingsScreens } from '../constants';
import MainBodyLayout from '../partials/MainBodyLayout';

const ConfirmExpeditedAmount = () => {
  const { t: translate } = useTranslation();
  const { state, openScreen } = useContext(CardSettingsContext);
  const history = useHistory();

  const cardStatus = state?.cardStatus;
  const screenOptions = state?.screenOptions;

  const [replacementFee] = useSetting('card_fees', `card_fee_galileo_expedited_replacement`);

  const reportCardKey = useMemo(() => {
    if (cardStatus?.is_replacement_requested === false) {
      return CARD_ORDER_REPLACEMENT;
    }

    if (screenOptions) {
      if (screenOptions.state === REPORT_CARD_STATUS.STOLEN) {
        return CARD_GALILEO_REPORT_STOLEN;
      }
      if (screenOptions.state === REPORT_CARD_STATUS.LOST) {
        return CARD_GALILEO_REPORT_LOST;
      }
      if (screenOptions.state === REPORT_CARD_STATUS.DAMAGEDNOTWORK) {
        return CARD_GALILEO_REPORT_DAMAGED;
      }
    }

    return null;
  }, [cardStatus?.is_replacement_requested, screenOptions]);

  const closeFlow = () => {
    history.push('/dashboard/card/details');
  };

  const { mutate: reportGalileoCard } = useMutation(reportCardKey, {
    onSettled: (data, error) => {
      if (error) {
        if (error?.message?.includes('balance')) {
          openScreen(cardSettingsScreens.ERROR_TX);
        } else {
          showAlert({ message: error.message, type: 'danger' });
        }
      } else {
        showAlert({
          message: translate('confirm_card_replacement_succes_expedited'),
          type: 'success',
        });
        closeFlow();
      }
    },
  });

  return (
    <MainBodyLayout
      withBack
      onPrevClick={() => openScreen(cardSettingsScreens.CONFIRM_DELIVERY_TYPE, screenOptions)}
      title={translate('card_order_confirm_payment_title')}>
      <div className="rounded-extra light-container p-3 mt-4">
        <div className="d-flex flex-row justify-content-between">
          <div>{translate('card_fees_to_pay')}</div>
          <div> {`${replacementFee.toFixed(2)} USD`}</div>
        </div>
      </div>

      <div className="alert alert-info d-flex mt-4">
        <i className="icon icon-info-icon" />
        <div className="content">{translate('card_fees_to_pay_info')}</div>
      </div>
      <div
        className={`d-flex flex-row mt-5 pt-3 ${
          isMobile ? 'position-fixed w-95 bg-light pb-3 pe-2' : 'mx-2 px-5'
        }`}
        style={{ bottom: '0', left: '0', zIndex: 100 }}>
        <button
          type="button"
          className="btn py-3 btn-primary w-100"
          onClick={() => {
            reportGalileoCard({
              order_replacement: true,
              use_expedited_shipping: true,
            });
          }}>
          {translate('continue_btn_title')}
        </button>
      </div>
    </MainBodyLayout>
  );
};

export default ConfirmExpeditedAmount;
